import {
  faCoffee,
  faHandshake,
  faSpinner,
  faUtensils,
  faUser,
  faUsers,
  faBan,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Fragment, useContext, useEffect, useRef, useState } from 'react';
import { Button, Table } from 'reactstrap';
import styled from 'styled-components';
import Swal from 'sweetalert2';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import {
  getPercentageTime,
  urlWithHttpProtocol,
  openUrlInNewTabOrDetectBlock,
  preOpenNamedMeetingWindow,
  shouldJoinMeetingButtonBeVisisble,
  determineProgress,
  checkForScheduleDisabledButton,
  cleanupOldAlertedEvents,
  isRezrateEmbeddedMeetingUrl as shouldResolveRezrateEmbeddedMeeting,
  checkIfMeetingIsBeforeCurrentJoinedMeeting,
} from '../../../../Common.functions.js';
import { Circle } from '../../../../Common.jsx.js';
import { renderAvatar } from './Common.js';
import { checkForSound } from './ScheduleAlerts.js';
import ScheduleItem from './ScheduleItem.js';
import BellSound from '../../../../assets/sounds/shipbell.wav';
import { clone } from '../../../../Services/schedule';
import { DepartmentContext } from 'DepartmentWrapper.js';
import {
  buildEmbeddedMeetingVideoUrl,
  buildRezrateVideoShellUrl,
  createOrReuseRezrateVideoSession,
  removeRezrateVideoSession,
  REZRATE_VIDEO_WINDOW_TARGET,
} from 'Services/rezrateVideoShell';
let tableRowOpacity = 0;

const diff_minutes = (dt2, dt1) => {
  var diff = (dt2.getTime() - dt1.valueOf()) / 1000;
  diff /= 60;
  return Math.abs(Math.round(diff));
};

const replaceWithNumber = '|###|';

const EvaluatorWorkspace = styled.div`
  display: flex;
  gap: 20px;
  align-items: stretch;
  width: 100%;

  @media (max-width: 1180px) {
    flex-direction: column;
  }
`;

const EvaluatorSchedulePane = styled.div`
  flex: ${({ $hasVideo }) => ($hasVideo ? '0 1 56%' : '1 1 100%')};
  min-width: 0;
`;

const Schedule = ({
  activeTab,
  alarms,
  allDayRoom,
  changeToCandidateTab,
  candidateInfo = [],
  date,
  differences,
  disableJoinMeetingButton,
  firstEvent,
  firstBlockEarlyJoin,
  getCandidate,
  handleDateChange,
  handleZoomClick,
  indexesWithDifferences,
  informUserMeetingIsStartingLocally,
  interviewIsToday,
  isEarlyMessageVisible = false,
  isEmbedded,
  isMobile,
  isPopout = false,
  match,
  mainRoomUrlDetails,
  postRequest,
  reduxDate,
  requestVirtualMeetingEvaluator,
  requestZoomMeeting,
  schedule,
  Schedules4Eval__pkUUID_Schedule,
  Schedules4EvalJoinManualURL,
  selectedCandidateIdLocal,
  selectedUser,
  setAlarms,
  setDate,
  setDisableJoinMeetingButton,
  setMyDate,
  setSchedules4Eval__pkUUID_Schedule,
  setSchedules4EvalJoinManualURL,
  setSelectedTimeSlot,
  selectedTimeSlot,
  setShowRed,
  setUserIdOnCurrentInterview,
  showRed,
  userIdOnCurrentInterview,
  setSelectedCandidate,
  virtualMeetingMode, // This is VirtualMeetingMode from the schedule metaData, not the dContext. dContext can be outdated.
  enableEmbeddedMeetings = false,
}) => {
  // React.useEffect(() => {
  //   var timerID = setInterval(() => tick(), 1000);
  //   return function cleanup() {
  //     clearInterval(timerID);
  //   };
  // });

  const [alertedEvents, setAlertedEvents] = useState([]);
  const [chosenCandidate, setChosenCandidate] = useState(null);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [currentTimeAsMoment, setCurrentTimeAsMoment] = useState(dayjs(new Date()));
  const [displayLocalNotification, setDisplayLocalNotification] = useState(true);
  const [heights, setHeights] = useState([]);
  const [preventJoinMeetingClick, setPreventJoinMeetingClick] = useState(false);
  const [scheduledTimes, setScheduledTimes] = useState(null);
  const [scheduleWithPassingPeriods, setScheduleWithPassingPeriods] = useState({});
  const [activeVideoSession, setActiveVideoSession] = useState(null);

  const scheduleActual = useRef([]);
  const alarmsActual = useRef([]);
  const activeVideoSessionRef = useRef(null);
  const pendingVideoWindowRef = useRef(null);

  const dContext = useContext(DepartmentContext);
  const hideCandidatePhotosFromEvaluators = Boolean(dContext?.department?.HideCandidatePhotosFromEvaluators);
  // Alert functionality replaced with toast

  useEffect(() => {
    activeVideoSessionRef.current = activeVideoSession;
  }, [activeVideoSession]);

  useEffect(() => {
    getAlertedEvents();
    // Permission is requested by the test button, never during schedule initialization.

    let audio = new Audio(BellSound);
    audio.volume = 0.0;
    audio
      .play()
      .then(() => {
        console.log('wakeup 0 volume played fine');
      })
      .catch((err) => {
        console.log('wakeup 0 volume err: ', err);
      });

    var timerID = setInterval(() => tick(), 1000);
    return function cleanup() {
      clearInterval(timerID);
    };
    // return function cleanup() {
    //   clearInterval(timerID);
    // };
  }, []);

  useEffect(() => {
    if (alarms) {
      alarmsActual.current = alarms || [];
    }
  }, [alarms]);

  useEffect(() => {
    if (schedule) {
      processSchedulesWithPassingPeriod(schedule);
      scheduleActual.current = schedule || [];
    }
  }, [schedule]);

  useEffect(() => {
    if (alertedEvents && alertedEvents.length > 0) {
      localStorage.setItem('evaluator_alertedEvents', JSON.stringify(alertedEvents));
    }
  }, [alertedEvents]);

  const processSchedulesWithPassingPeriod = (schedule) => {
    const scheduleObject = scheduleWithPassingPeriods;

    schedule.forEach((item, i) => {
      const { pk_ScheduleAssignment, pk_Timeslot, pk_ScheduleBlock, isPassingPeriod, isFiller, isRedirect } = item;

      const key = `${pk_Timeslot}_${pk_ScheduleAssignment}_${pk_ScheduleBlock}`;
      if (isPassingPeriod || isFiller || isRedirect) {
        return;
      }

      let passingPeriodEnd;
      if (schedule[i + 1] && schedule[i + 1].isPassingPeriod) {
        passingPeriodEnd = schedule[i + 1].EndTimeAsMoment;
      } else {
        passingPeriodEnd = schedule[i].EndTimeAsMoment;
      }
      scheduleObject[key] = passingPeriodEnd;
    });

    setScheduleWithPassingPeriods(scheduleObject);
  };

  // useEffect(() => {
  //   if (scheduleWithPassingPeriods) {
  //     console.log('scheduleWithPassingPeriods: ', scheduleWithPassingPeriods);
  //   }
  // }, [scheduleWithPassingPeriods]);

  const handlePartialUnavailability = (item) => {
    const { EnableEvaluatorIsUnavailable, UnavailableOverlaps, isScheduleBlock } = item;

    if (!EnableEvaluatorIsUnavailable || !isScheduleBlock) {
      return null;
    }

    return (
      <Fragment>
        {UnavailableOverlaps.map((item, i) => {
          return (
            <p style={{ margin: 0 }}>
              <FontAwesomeIcon color="#cf142b" icon={faBan} /> You are unavailable from {item.StartTimeFormatted}-
              {item.EndTimeFormatted}
            </p>
          );
        })}
      </Fragment>
    );
  };

  const determineEvent = (item) => {
    if (item.isFlexEvent) {
      return (
        <div>
          <h4 style={{ fontWeight: 700, margin: 0, fontSize: 16 }}>{item.EventName}</h4>
          {handlePartialUnavailability(item)}
        </div>
      );
    }
    if (item.isPassingPeriod) {
      return <h6 style={{ margin: 0, fontSize: 16 }}>Passing Period</h6>;
    }

    if (item.isCustomMeeting) {
      const { CustomMeetingTitle } = item;
      return (
        <div>
          <h4 style={{ fontWeight: 700, margin: 0, fontSize: 16 }}>{CustomMeetingTitle}</h4>
        </div>
      );
    }

    if (item.isFiller) {
      return <h5 style={{ fontSize: 16 }}>Break</h5>;
    }

    if (item.Candidates && item.Candidates.length > 0) {
      return item.Candidates.map((candidate) => {
        const { FirstName, LastName } = candidate;

        const detailedCandidate = candidateInfo
          ? candidateInfo.find((c) => {
              return c.pk_Candidate == candidate.pk_Candidate;
            })
          : {};

        return (
          <div key={candidate.pk_Candidate} id={`mySchedule_scrollID_${candidate.pk_Candidate}`}>
            <h4 style={{ fontWeight: 700, margin: 0, fontSize: 16 }}>
              {LastName}, {FirstName}
            </h4>
            <p style={{ margin: 0, fontWeight: 700, fontSize: 12 }}>
              {detailedCandidate && detailedCandidate.CandidateSubHeading ? detailedCandidate.CandidateSubHeading : ''}
            </p>
            {handlePartialUnavailability(item)}
            <div>{detailedCandidate ? determineProgress(detailedCandidate.Status) : ''}</div>
          </div>
        );
      });
    }

    if (item.Schedules4EvalAltText && item.Schedules4EvalAltText.length > 0)
      return <h5 style={{ fontSize: 16 }}>{item.Schedules4EvalAltText}</h5>;

    return <h5 style={{ fontSize: 16 }}>Break</h5>;
  };

  const getAlertedEvents = () => {
    // Clean up old alerted events (older than 48 hours)
    const cleanedEvents = cleanupOldAlertedEvents('evaluator_alertedEvents');
    if (cleanedEvents && cleanedEvents.length > 0) {
      setAlertedEvents(cleanedEvents);
    }
  };

  const closeWindowIfOpen = (targetWindow) => {
    if (!targetWindow) {
      return;
    }

    try {
      if (!targetWindow.closed) {
        targetWindow.close();
      }
    } catch (error) {
      // ignore close errors
    }
  };

  const prepareEvaluatorMeetingWindow = () => {
    const popupWindow = preOpenNamedMeetingWindow(REZRATE_VIDEO_WINDOW_TARGET);
    pendingVideoWindowRef.current = popupWindow;
    return popupWindow;
  };

  const takePendingEvaluatorMeetingWindow = () => {
    const popupWindow = pendingVideoWindowRef.current;
    pendingVideoWindowRef.current = null;
    return popupWindow;
  };

  const closePendingEvaluatorMeetingWindow = () => {
    closeWindowIfOpen(takePendingEvaluatorMeetingWindow());
  };

  const reusePopupForSession = (session, preOpenedWindow = null) => {
    if (!session || !session.id) {
      return false;
    }

    return openUrlInNewTabOrDetectBlock(
      buildRezrateVideoShellUrl(session.id),
      REZRATE_VIDEO_WINDOW_TARGET,
      preOpenedWindow,
    );
  };

  const discardActiveVideoSession = () => {
    const currentSession = activeVideoSessionRef.current;
    if (currentSession && currentSession.id) {
      removeRezrateVideoSession(currentSession.id);
    }
    setActiveVideoSession(null);
  };

  const getMeetingShellTitle = (item) => {
    if (!item) {
      return 'RezRATE Meeting';
    }
    if (item.EventName) {
      return item.EventName;
    }
    if (item.CustomMeetingTitle) {
      return item.CustomMeetingTitle;
    }
    if (item.Users && item.Users.length > 0) {
      return 'Evaluator Interview Meeting';
    }
    return 'RezRATE Meeting';
  };

  const activateEmbeddedMeeting = ({ config, item }) => {
    const preOpenedWindow = takePendingEvaluatorMeetingWindow();
    const iframeSrc = buildEmbeddedMeetingVideoUrl(config, {
      returnUrl: window.location.href,
    });

    if (!iframeSrc) {
      closeWindowIfOpen(preOpenedWindow);
      Swal.fire('Error!', 'Unable to start embedded meeting (missing session token).', 'error');
      return false;
    }

    const currentSession = activeVideoSessionRef.current;
    const { session: nextSession, reusedExisting } = createOrReuseRezrateVideoSession({
      iframeSrc,
      title: getMeetingShellTitle(item),
    });

    if (!nextSession) {
      closeWindowIfOpen(preOpenedWindow);
      Swal.fire('Error!', 'Unable to prepare the meeting shell.', 'error');
      return false;
    }

    const reusedPopup = reusePopupForSession(nextSession, preOpenedWindow);
    if (!reusedPopup) {
      if (!(reusedExisting && currentSession && currentSession.id === nextSession.id)) {
        removeRezrateVideoSession(nextSession.id);
      }
      closeWindowIfOpen(preOpenedWindow);
      Swal.fire('Error!', 'Please allow RezRATE to open the meeting window.', 'error');
      return false;
    }

    if (currentSession && currentSession.id && currentSession.id !== nextSession.id) {
      removeRezrateVideoSession(currentSession.id);
    }

    setActiveVideoSession(nextSession);
    localStorage.setItem('evaluator_lastJoinedMeeting', JSON.stringify(item));
    return true;
  };

  const openURLInNewTab = (urlFormatted, preOpenedWindow = null) => {
    const formatted = `${urlWithHttpProtocol(urlFormatted) || ''}`;
    if (!formatted) {
      closeWindowIfOpen(preOpenedWindow);
      return false;
    }
    const opened = openUrlInNewTabOrDetectBlock(
      formatted,
      REZRATE_VIDEO_WINDOW_TARGET,
      preOpenedWindow || takePendingEvaluatorMeetingWindow(),
    );
    if (!opened) {
      closeWindowIfOpen(preOpenedWindow);
      Swal.fire('Error!', 'Please allow RezRATE to open the meeting window.', 'error');
      return false;
    }
    return true;
  };

  const showJoinMeetingButton = (url, priorityUrl, Schedules4Portal__pkUUID_Schedule, message = '', item) => {
    const demo = false;

    const isBreakItem = !item.isFlexEvent && !item.isCustomMeeting && !item.isScheduleBlock;

    if (isBreakItem && !allDayRoom) {
      return;
    }
    return (
      <Fragment>
        <br />
        <Button
          color={isBreakItem ? 'warning' : 'success'}
          size="sm"
          disabled={
            disableJoinMeetingButton ||
            (!date && !reduxDate) ||
            checkForScheduleDisabledButton(item, currentTimeAsMoment)
          }
          style={{ minWidth: '95px' }}
          onClick={async (e) => {
            e.preventDefault();
            const pendingVideoWindow = prepareEvaluatorMeetingWindow();
            if (checkForScheduleDisabledButton(item, dayjs())) {
              closeWindowIfOpen(pendingVideoWindow);
              Swal.fire('Meeting Ended', 'This meeting is no longer available to join.', 'info');
              return;
            }

            let urlToUse = allDayRoom;
            let nonZoomInfoToUse = mainRoomUrlDetails || '';
            const {
              VirtualRoomType,
              isCustomMeeting,
              CustomMeetingUrl,
              CustomMeetingDetails,
              CustomUrl,
              CustomUrlDescription,
              isFlexEvent,
              isScheduleBlock,
              UrlType,
              pk_Timeslot,
              pk_InterviewDate,
              EndTimeAsMoment,
              StartTimeAsMoment,
            } = item;

            if (isScheduleBlock) {
              let response = null;
              try {
                response = await requestVirtualMeetingEvaluator(item);
              } catch (err) {
                closePendingEvaluatorMeetingWindow();
                Swal.fire('Error!', `Unable to start meeting: ${err.message || 'Network error'}`, 'error');
                return;
              }
              if (!response) {
                return;
              }
              localStorage.setItem('evaluator_lastJoinedMeeting', JSON.stringify(item));
              const { data } = response || {};
              const embeddedConfig = data?.config?.config || data?.config || null;

              // Embedded Zoom meeting flow
              if (embeddedConfig && (embeddedConfig.videoSDKJWT || embeddedConfig.signature)) {
                activateEmbeddedMeeting({ config: embeddedConfig, item });
                return;
              }

              // Legacy Zoom join flow
              const { DialInNumbers, JoinURL, MeetingId, Password } = data || {};
              if (!JoinURL) {
                closePendingEvaluatorMeetingWindow();
                Swal.fire('Error!', 'No meeting to join. Please contact the coordinator.', 'error');
                return;
              }
              handleZoomClick({
                url: JoinURL,
                mobileNumbers: DialInNumbers,
                password: Password,
                meetingId: MeetingId,
                preOpenedWindow: takePendingEvaluatorMeetingWindow(),
              });
              return;
            }

            if (isCustomMeeting) {
              if (VirtualRoomType === 'Custom' && CustomMeetingUrl) {
                urlToUse = CustomMeetingUrl;
                nonZoomInfoToUse = CustomMeetingDetails;
              }
            }

            if (isFlexEvent && UrlType) {
              if (UrlType === 'AllDay') {
              } else {
                urlToUse = CustomUrl;
                nonZoomInfoToUse = CustomUrlDescription;
              }
            }

            // When embedded meetings are enabled, an all-day / main-room event is joined through the
            // API-minted embedded session even if the Main Room URL was never set to the embedded
            // sentinel. Mirrors the candidate Welcome fallback; gated on enableEmbeddedMeetings so
            // non-embedded departments keep the standard flow.
            const shouldEmbeddedFallback =
              enableEmbeddedMeetings &&
              virtualMeetingMode === 'Internal' &&
              ((isFlexEvent && UrlType === 'AllDay') || (isCustomMeeting && VirtualRoomType !== 'Custom'));

            if (urlToUse) {
              if (shouldResolveRezrateEmbeddedMeeting(urlToUse)) {
                let response = null;
                try {
                  response = await requestVirtualMeetingEvaluator(item);
                } catch (err) {
                  closePendingEvaluatorMeetingWindow();
                  Swal.fire('Error!', `Unable to start embedded meeting: ${err.message || 'Network error'}`, 'error');
                  return;
                }
                if (!response) {
                  return;
                }
                const { data } = response || {};
                const embeddedConfig = data?.config?.config || data?.config || null;
                if (embeddedConfig && (embeddedConfig.videoSDKJWT || embeddedConfig.signature)) {
                  activateEmbeddedMeeting({ config: embeddedConfig, item });
                  return;
                }
                closePendingEvaluatorMeetingWindow();
                Swal.fire('Error!', 'Unable to start embedded meeting.', 'error');
                return;
              }

              if (openURLInNewTab(urlWithHttpProtocol(urlToUse), pendingVideoWindow)) {
                discardActiveVideoSession();
              }
            } else if (shouldEmbeddedFallback) {
              let response = null;
              try {
                response = await requestVirtualMeetingEvaluator(item);
              } catch (err) {
                closePendingEvaluatorMeetingWindow();
                Swal.fire('Error!', `Unable to start embedded meeting: ${err.message || 'Network error'}`, 'error');
                return;
              }
              if (!response) {
                return;
              }
              const { data } = response || {};
              const embeddedConfig = data?.config?.config || data?.config || null;
              if (embeddedConfig && (embeddedConfig.videoSDKJWT || embeddedConfig.signature)) {
                activateEmbeddedMeeting({ config: embeddedConfig, item });
                return;
              }
              closePendingEvaluatorMeetingWindow();
              Swal.fire(
                'Error!',
                'No link to join. No event has been created. Please contact your coordinator.',
                'error',
              );
            } else {
              closeWindowIfOpen(pendingVideoWindow);
              Swal.fire(
                'Error!',
                'No link to join. No event has been created. Please contact your coordinator.',
                'error',
              );
            }
          }}
        >
          {disableJoinMeetingButton ? (
            <FontAwesomeIcon icon={faSpinner} spin />
          ) : item.isFlexEvent || item.isCustomMeeting || item.isScheduleBlock ? (
            'Join Meeting'
          ) : (
            'Visit Break Room'
          )}
          {message}
        </Button>
      </Fragment>
    );
  };

  const tick = () => {
    try {
      var rightNow = new Date();
      // need to get rid of the user's offset in order to correctly calculate
      if (scheduleActual.current && !isEmbedded) {
        const lastJoinedMeeting = localStorage.getItem('evaluator_lastJoinedMeeting');
        // TODO: check if lastMeeting is different from current lastMeeting.
        scheduleActual.current.forEach((element, i) => {
          const { pk_Timeslot, isRedirect } = element;
          if (isRedirect) {
            return;
          }
          if (
            !isRedirect &&
            diff_minutes(rightNow, element.StartTimeAsMoment) === 0 &&
            displayLocalNotification &&
            element.Candidates4DateNameFull &&
            element.Candidates4DateNameFull !== ''
          ) {
            informUserMeetingIsStartingLocally(setDisplayLocalNotification);
          }
          let itemAfterIsSameRow = false; // If same row, it means it's a split. We don't do passing periods within and after split cells.
          let itemBeforeIsSameRow = false;

          let itemBefore = schedule[i - 1] ? schedule[i - 1] : null;
          let itemAfter = schedule[i + 1] ? schedule[i + 1] : null;

          const itemIsBeforeCurrentMeeting = lastJoinedMeeting
            ? checkIfMeetingIsBeforeCurrentJoinedMeeting({
                lastJoinedMeeting: lastJoinedMeeting ? JSON.parse(lastJoinedMeeting) : null,
                itemToCheck: element,
              })
            : false;

          // Suppres notifs for Meetings before last joined meeting.
          if (itemIsBeforeCurrentMeeting) {
            return;
          }

          if (itemAfter != null && !itemAfter.isPassingPeriod) {
            itemAfterIsSameRow = pk_Timeslot == itemAfter.pk_Timeslot;
          }

          if (itemBefore != null && !itemBefore.isPassingPeriod) {
            itemBeforeIsSameRow = pk_Timeslot == itemBefore.pk_Timeslot;
          }

          checkForAlarm(element, { hasPassingPeriod: !itemAfterIsSameRow && !itemBeforeIsSameRow, lastJoinedMeeting });
        });
      }

      if (scheduleActual.current && document.getElementById('tableRow0')) {
        let heights = [];
        scheduleActual.current.forEach((element, i) => {
          if (!document.getElementById('tableRow' + i)) {
            return;
          }
          const height = document.getElementById('tableRow' + i).clientHeight;
          heights.push(height);
        });
        setHeights(heights);
      }
      setCurrentTime(rightNow);
      setCurrentTimeAsMoment(dayjs(rightNow));
    } catch (err) {
      console.log('tick err: ', err);
    }
  };

  const checkForAlarm = (item, options) => {
    const { hasPassingPeriod, lastJoinedMeeting } = options;
    const {
      Candidates = [],
      pk_Timeslot,
      pk_ScheduleAssignment,
      pk_ScheduleBlock,
      EndTimeAsMoment,
      StartTimeAsMoment,
      SortOrder,
      isPassingPeriod,
      isFlexEvent,
      isScheduleBlock,
      isCustomMeeting,
      isFiller,
      pk_InterviewDate,
    } = item;
    const trackerKey = `${pk_Timeslot}_${pk_ScheduleAssignment}_${pk_ScheduleBlock}`;
    const itemIsBreak = !isCustomMeeting && !isFlexEvent && !isScheduleBlock && !isPassingPeriod && isFiller;

    if ((Candidates.length > 0 || isFlexEvent || isCustomMeeting || isScheduleBlock) && !isFiller) {
      const eventEndTime = EndTimeAsMoment;
      const eventEndTimeWithPassing = scheduleWithPassingPeriods[trackerKey];

      const formattedEndTime = EndTimeAsMoment.format('MMM DD, YYYY HH:mm A');
      const formattedStartTime = StartTimeAsMoment.format('MMM DD, YYYY HH:mm A');

      const now = dayjs();
      const realAlertedEvents = localStorage.getItem('evaluator_alertedEvents')
        ? JSON.parse(localStorage.getItem('evaluator_alertedEvents'))
        : [];

      const newAlertedEvents = realAlertedEvents.slice();

      alarmsActual.current.forEach((a) => {
        const { Message, pk_Alert, Type } = a;
        const alertMinutes = a.Minutes;
        const key = `evaluator_${formattedStartTime}_${formattedEndTime}_${pk_Alert}_${pk_Timeslot}_${pk_InterviewDate}`;

        // Update top deal with non-filler non-passing period items
        let diffActual = 0;

        if (Type === 'End of Meeting') {
          diffActual = eventEndTime.diff(now, 'minutes', true);
        }

        if (Type === 'End of Passing') {
          diffActual = eventEndTimeWithPassing.diff(now, 'minutes', true);
        }

        const alertIsNow = diffActual >= -1 && diffActual <= alertMinutes;
        const alertIsInThePast = diffActual < -1;

        if (alertIsNow && !realAlertedEvents.includes(key)) {
          if (Type === 'End of Meeting' || (Type === 'End of Passing' && hasPassingPeriod)) {
            // console.log('firing for: ', item);
            // console.log('Type: ', Type);
            // console.log('Message: ', Message);
            // console.log('formattedStartTime: ', formattedStartTime);
            // console.log('hasPassingPeriod: ', hasPassingPeriod);
            // console.log('diffActual: ', diffActual);
            // console.log('alertMinutes: ', alertMinutes);
            try {
              new Notification(`${Message}`);
            } catch (e) {
              console.log('Failed to fire notif. Err: ', e);
            }

            if (a.Sound === 'Bell') {
              let audio = new Audio(BellSound);
              audio.volume = 0.9;
              audio
                .play()
                .then(() => {
                  console.log('alert played fine');
                })
                .catch((err) => {
                  console.log('alert failed to play. err: ', err);
                });
            }

            toast.info(`${Message}`, { autoClose: 10000 });
          } else {
            // console.log('was about to fire end of passing, but is a split cell');
          }
        }

        if (alertIsNow || alertIsInThePast) {
          // const newAlertedEvents = realAlertedEvents.slice();
          if (!newAlertedEvents.includes(key)) {
            newAlertedEvents.push(key);

            localStorage.setItem('evaluator_alertedEvents', JSON.stringify(newAlertedEvents));
            setAlertedEvents(newAlertedEvents);
          }
        }
      });
    }
  };

  const determineIcon = (item) => {
    if (item.Schedules4EvalAltText === 'passing period') {
      return <div />;
    }
    const returnBreak = () => {
      if (item.isPassingPeriod) return <div></div>;

      return (
        <div style={{ width: '52px', height: '52px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <FontAwesomeIcon icon={faCoffee} style={{ fontSize: '2em' }} color="var(--rr-ink)" />
        </div>
      );
    };

    const {
      isCustomMeeting,
      isFiller,
      isScheduleBlock,
      isPassingPeriod,
      Candidates,
      isFlexEvent,
      CustomMeetingTitle = '',
    } = item;

    if (Candidates && Candidates.length > 0) {
      const singleCandidateWithPhoto =
        Candidates.length === 1 && Candidates[0].PhotoUrl && Candidates[0].PhotoUrl !== '' ? true : false;
      const singleCandidateWithoutPhoto = Candidates.length === 1 && !Candidates[0].PhotoUrl;
      const multipleCandidates = Candidates.length > 1;
      return (
        <div style={{ position: 'relative', top: 0 }}>
          <div style={{ minHeight: '52px', display: 'flex', alignItems: 'center' }}>
            {singleCandidateWithPhoto && <img style={{ width: '52px', height: 'auto' }} src={Candidates[0].PhotoUrl} />}
            {singleCandidateWithoutPhoto && (
              <div
                style={{
                  height: '53px',
                  width: '53px',
                  // border: '1px solid rgb(51, 51, 51)',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <FontAwesomeIcon icon={multipleCandidates ? faUsers : faUser} style={{ fontSize: '2.67em' }} />
              </div>
            )}
            {item.Candidates4DateDNRStatus === 1 && (
              <div style={{ position: 'absolute', bottom: 0, left: '58px' }}>
                <Circle>
                  <p style={{ padding: 0, margin: 0, fontSize: '.7em' }}>DNR</p>
                </Circle>
              </div>
            )}
          </div>
        </div>
      );
    }

    if (isFlexEvent) {
      const { FlexEvent = {}, EventName } = item;
      const { Candidates = [] } = FlexEvent;
      const candidateCount = Candidates.length;
      const showCount =
        EventName.toUpperCase() !== 'LUNCH' &&
        EventName.toUpperCase() !== 'DINNER' &&
        EventName.toUpperCase() !== 'BREAK' &&
        EventName.toUpperCase() !== 'UNAVAILABLE';
      let eventIcon = faHandshake;

      switch (EventName.toUpperCase()) {
        case 'BREAK':
          eventIcon = faCoffee;
          break;
        case 'LUNCH':
          eventIcon = faUtensils;
          break;
        case 'DINNER':
          eventIcon = faUtensils;
          break;
        case 'UNAVAILABLE':
          eventIcon = faBan;
          break;
        default:
          eventIcon = faHandshake;
          break;
      }

      return (
        <div
          style={{
            width: '52px',
            height: '52px',
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            marginTop: 10,
          }}
        >
          <FontAwesomeIcon icon={eventIcon} style={{ fontSize: '2em' }} color="var(--rr-ink)" />
          {showCount ? (
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                fontSize: 12,
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <FontAwesomeIcon icon={faUser} color="var(--rr-ink)" style={{ marginRight: 2 }} /> x{candidateCount}
            </div>
          ) : null}
        </div>
      );
    }

    if (isCustomMeeting) {
      const firstLetter = item.CustomMeetingTitle.charAt(0).toUpperCase();
      let eventIcon = null;
      switch (CustomMeetingTitle.toUpperCase()) {
        case 'BREAK':
          eventIcon = faCoffee;
          break;
        case 'LUNCH':
          eventIcon = faUtensils;
          break;
        case 'DINNER':
          eventIcon = faUtensils;
          break;
        default:
          eventIcon = null;
      }
      return (
        <div style={{ width: '52px', height: '52px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          {eventIcon ? (
            <FontAwesomeIcon icon={eventIcon} style={{ fontSize: '2em' }} color="var(--rr-ink)" />
          ) : (
            <h2 style={{ fontWeight: '700', fontSize: 32 }}>{firstLetter}</h2>
          )}
        </div>
      );
    }
    return returnBreak();
  };

  const joinMeetingButton = (joinMeetingButtonVisible, interviewIsToday, item) => {
    // if item is a filler or a passing period it shouldn't return a buttton

    const shouldBeVisible = shouldJoinMeetingButtonBeVisisble(item, null, currentTimeAsMoment);

    if (shouldBeVisible && virtualMeetingMode !== 'Disabled') {
      return (
        <span>
          {showJoinMeetingButton(
            '',
            item.Schedules4EvalJoinManualURL,
            item.Schedules4Eval__pkUUID_Schedule,
            item.message,
            item,
          )}
        </span>
      );
    }
  };

  const handleIterativeVariables = (item) => {
    //Variables are being set this way because CandidateAlphabetical needs to know
    // about which schedule item is currently active.  This is being determined
    // by this Schedule component so in order to communicate this to CandidateAlphabetical
    // I'm setting state in their parent component

    if (item.Schedules4Eval__pkUUID_Schedule !== Schedules4Eval__pkUUID_Schedule) {
      setSchedules4Eval__pkUUID_Schedule(item.Schedules4Eval__pkUUID_Schedule);
    }

    if (Schedules4EvalJoinManualURL !== item.Schedules4EvalJoinManualURL) {
      setSchedules4EvalJoinManualURL(item.Schedules4EvalJoinManualURL);
    }

    if (typeof item.Candidates4Date__pkUUID_Candidate === 'undefined' && userIdOnCurrentInterview !== null) {
      setUserIdOnCurrentInterview(null);
    }

    if (item.Candidates4Date__pkUUID_Candidate && item.Candidates4Date__pkUUID_Candidate !== userIdOnCurrentInterview) {
      setUserIdOnCurrentInterview(item.Candidates4Date__pkUUID_Candidate);
    }
  };

  return (
    <>
      {hideCandidatePhotosFromEvaluators && (
        <div
          style={{
            backgroundColor: '#fff3cd',
            border: '1px solid #ffeeba',
            color: '#856404',
            borderRadius: 4,
            padding: '8px 12px',
            marginBottom: 10,
            fontWeight: 600,
          }}
        >
          Candidate photos are hidden from evaluators. Silhouette placeholders are shown instead.
        </div>
      )}
      <EvaluatorWorkspace>
        <EvaluatorSchedulePane $hasVideo={Boolean(activeVideoSession)}>
          <div
            id="evaluation-table-wrapper"
            style={{
              width: '100%',
              height: isMobile
                ? `calc(100vh - ${isEarlyMessageVisible ? 290 : 230}px)`
                : `calc(100vh - ${(isEarlyMessageVisible ? 270 : 210) + (isPopout ? 90 : 0)}px)`,
              minHeight: 260,
              backgroundColor: 'var(--rr-surface)',
              overflowY: 'auto',
            }}
          >
            <Table style={{ marginBottom: 0 }}>
              <tbody>
                {schedule && schedule.length > 0 ? (
                  schedule.map((item, i) => {
                    const { SortOrder } = item;
                    const itemBefore = schedule[i - 1];
                    let index = i;
                    // if (itemBefore && itemBefore.isRedirect) {
                    //   index = i - 1;
                    // }
                    return (
                      <ScheduleItem
                        // TODO: give this a proper key
                        candidateInfo={candidateInfo}
                        changeToCandidateTab={changeToCandidateTab}
                        chosenCandidate={chosenCandidate}
                        currentTime={currentTime}
                        currentTimeAsMoment={currentTimeAsMoment}
                        date={date}
                        determineEvent={determineEvent}
                        determineIcon={determineIcon}
                        differences={differences}
                        firstBlockEarlyJoin={firstBlockEarlyJoin}
                        firstEvent={firstEvent}
                        getCandidate={getCandidate}
                        getPercentageTime={getPercentageTime}
                        handleDateChange={handleDateChange}
                        handleIterativeVariables={handleIterativeVariables}
                        heights={heights}
                        i={index}
                        indexesWithDifferences={indexesWithDifferences}
                        interviewIsToday={interviewIsToday}
                        isMobile={isMobile}
                        isPassingPeriod={item.Schedules4EvalAltText === 'passing period'}
                        item={item}
                        joinMeetingButton={joinMeetingButton}
                        key={`${SortOrder}${i}`}
                        prevItem={schedule[i - 1]}
                        reduxDate={reduxDate}
                        requestVirtualMeetingEvaluator={requestVirtualMeetingEvaluator}
                        selectedCandidateIdLocal={selectedCandidateIdLocal}
                        selectedTimeSlot={selectedTimeSlot}
                        setChosenCandidate={setChosenCandidate}
                        setDate={setDate}
                        setSelectedCandidate={setSelectedCandidate}
                        setSelectedTimeSlot={setSelectedTimeSlot}
                        setUserIdOnCurrentInterview={setUserIdOnCurrentInterview}
                        showRed={showRed}
                        tableRowOpacity={tableRowOpacity}
                        userIdOnCurrentInterview={userIdOnCurrentInterview}
                      />
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={4} style={{ display: 'flex', justifyContent: 'center', padding: 30 }}>
                      No Schedule Available
                    </td>
                  </tr>
                )}
                <tr></tr>
              </tbody>
            </Table>
          </div>
        </EvaluatorSchedulePane>
      </EvaluatorWorkspace>
    </>
  );
};

export default Schedule;
